export const wbsCodeDefaultValues = {
  prefix: '',
  code: '',
  name: '',
  parentId: null,
};
